import { Box, Card, IconButton, InputAdornment, Switch, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { GstDataContext } from './Gst';
import { DataGrid } from '@mui/x-data-grid';
import Loading from '../../../../components/Loader/Loading';
import NoRowsLayout from '../../../../components/Layout/NoRowsLayout';
import { Edit } from '@mui/icons-material';
import MultiColumnFilter from '../../../../components/Filter/MultiColumnFilter';
import SingleColumnFilter from '../../../../components/Filter/SingleColumnFilter';
import { Search } from '@mui/icons-material';
import { PermissionGuard } from '../../../../components/PermissionGuard';
import { usePermission } from '../../../../hooks/usePermission';
import useResponsive from '../../../../hooks/useResponsive'

const GstTable = () => {
  const {isSm} = useResponsive();
  const userPermissions = usePermission("gst");
  const showActionColumn = userPermissions.canEdit;
    const {gstList,fetchGstList,paginationModel,setPaginationModel,totalRowCount,loadingList, setSelectedGstData} = useContext(GstDataContext);
    const columns = [
        {field:'sac',headerName:'Sac Code',headerAlign:'center',sortable:false,flex:.5,
            renderCell : (params)=>(
                <Box sx={{width:'100%',textAlign:'center'}}>
                    <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e'}} >{params.row.sac}</Typography>
                </Box>
            )
        },
        {field:'slab',headerName:'Tax Slab',headerAlign:'center',sortable:false,flex:1.5,
            renderCell : (params)=>(
                <Box sx={{width:'100%',display:'flex',gap:'.5%',p:1}}>
                    <Box sx={{width:'45%'}}>
                        <Box sx={{display:'flex',gap:1, }}>
                            <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'45%',fontWeight:600}} >IGST</Typography>
                            <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'1%'}} >:</Typography>
                            <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e'}} >{params.row.igst}</Typography>
                        </Box>
                        <Box sx={{display:'flex',gap:1, }}>
                            <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'45%',fontWeight:600}} >CGST</Typography>
                            <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'1%'}} >:</Typography>
                            <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e'}} >{params.row.cgst}</Typography>
                        </Box>
                        <Box sx={{display:'flex',gap:1, }}>
                            <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'45%',fontWeight:600}} >SGST</Typography>
                            <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'1%'}} >:</Typography>
                            <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e'}} >{params.row.sgst}</Typography>
                        </Box>
                    </Box>
                    <Box sx={{width:'54%'}}>
                        <Box sx={{display:'flex',gap:1, }}>
                            <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'75%',fontWeight:600}} >IGST_Non</Typography>
                            <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'1%'}} >:</Typography>
                            <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'24%'}} >{params.row.igstNon}</Typography>
                        </Box>
                        <Box sx={{display:'flex',gap:1, }}>
                            <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'75%',fontWeight:600}} >CGST_Non</Typography>
                            <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'1%'}} >:</Typography>
                            <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'24%'}} >{params.row.cgstNon}</Typography>
                        </Box>
                        <Box sx={{display:'flex',gap:1, }}>
                            <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'75%',fontWeight:600}} >SGST_Non</Typography>
                            <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'1%'}} >:</Typography>
                            <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e',width:'24%'}} >{params.row.sgstNon}</Typography>
                        </Box>
                    </Box>
                </Box>
            )
        },
        {field:'title',headerName:'Title',headerAlign:'center',sortable:false,flex:1.25,
            renderCell : (params)=>(
                <Box sx={{width:'100%',p:.5}}>
                    <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e'}} >{params.row.title}</Typography>
                </Box>
            )
        },
        {field:'rcm',headerName:'RCM',headerAlign:'center',sortable:false,flex:.35,
            renderCell : (params)=>(
                <Box sx={{width:'100%',textAlign:'center'}}>
                    <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e'}} >{params.row.rcm? 'True':'False'}</Typography>
                </Box>
            )
        },
        {field:'tcs',headerName:'TCS',headerAlign:'center',sortable:false,flex:.25,
            renderCell : (params)=>(
                <Box sx={{width:'100%',textAlign:'center'}}>
                    <Typography sx={{fontSize:'0.65rem',fontweight:500,color:'#3e3e3e'}} >{params.row.tcs}</Typography>
                </Box>
            )
        },
        ...(showActionColumn ? [
          {
            field: 'action', 
            headerName: 'Action', 
            headerAlign: 'center', 
            flex: 0.25,
            renderCell: (params) => (
              <Box sx={{ width: '100%', textAlign: 'center' }}>
                <IconButton 
                  size="small" 
                  color="primary" 
                  onClick={() => setSelectedGstData(params.row)}
                >
                  <Edit fontSize="small" />
                </IconButton>
              </Box>
            ),
          }
        ] : []),
    ]

    const handlePaginationChange = (newPagination) => {
        setPaginationModel({
            ...paginationModel,
            page: newPagination.page,
            pageSize: newPagination.pageSize
        });
    }
    
    useEffect(()=>{
        fetchGstList();
    },[paginationModel]);
    /************  MultiColumn FIlter related  **************/
    const filterableColumns = [
        {
          key: 'sac',
          label: 'Sac Code',
          type: 'text'
        },
        {
          key: 'rcm',
          label: 'RCM',
          type: 'select',
          options: [
            { value: true, label: 'True' },
            { value: false, label: 'False' }
          ]
        },
        {
          key: 'tcs',
          label: 'TCS',
          type: 'select',
          options: [
            { value: '0', label: '0' },
            { value: '1', label: '1' }
          ]
        },
        {
          key: 'igst',
          label: 'Tax Slab',
          type: 'select',
          options: [
            { value: '0', label: '0 %' },
            { value: '5', label: '5 %' },
            { value: '12', label: '12 %' },
            { value: '18', label: '18 %' },
            { value: '28', label: '28 %' }
          ]
        }
    ];
    const handleApplyFilter = (filterData) => {
        // Process filter data
        console.log(filterData);
        setPaginationModel({
          ...paginationModel,
          page: 0, // Reset to first page when applying new filters
          filters: {
            ...paginationModel.filters,
            // Convert MultiColumnFilter options to a format your backend can understand
          filterOptions: filterData.filterOption.filter(filter => filter.fieldName && filter.value) // Remove empty filters
          }
        });
    }
    const [clearMultiFilter, setClearMultiFilter] = useState(false);

    /************* quick search related **************/
    const [quickFilterText, setQuickFilterText] = useState('');
    // Properly structured filter model
    const [filterModel, setFilterModel] = useState({
      items: [],
      quickFilterValues: []
    });

    // Update filter model when quick filter text changes
    useEffect(() => {
      setFilterModel(prevModel => ({
        ...prevModel,
        quickFilterValues: quickFilterText ? [quickFilterText] : []
      }));
    }, [quickFilterText]);

  return (
    <Card>
        <Box sx={{p:'.5% 1%',border:'2px solid lightGray',bgcolor:'lightGray'}}>
            <Typography sx={{fontWeight:600,fontSize:'0.85rem'}} >GST List</Typography>
        </Box>
        <Box>
            {/* custom toolbar */}
            <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between',alignItems:'center',px:'1%' }}>
              <Box sx={{ display: 'flex', gap: 1 }}>
                {/* <MultiColumnFilter
                  filterableColumns={filterableColumns}
                  onApplyFilter={handleApplyFilter}
                  externalClear={clearMultiFilter}
                //   defaultFilterOptions={paginationModel.filters.filterOptions}
                /> */}
                <SingleColumnFilter
                    filterableColumns={filterableColumns}
                    onApplyFilter={handleApplyFilter}
                    externalClear={clearMultiFilter}
                />
                {/* <ExportAll 
                  paginationModel={paginationModel} 
                  columns={columns} 
                  // statusOptions={statusOptions} 
                /> */}
              </Box>
              <Box>
                <TextField
                  value={quickFilterText}
                  onChange={(event) => setQuickFilterText(event.target.value)}
                  placeholder="Quick Search ..."
                  size="small"
                  fullWidth
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      paddingLeft: '0px',
                    }
                  }}
                  InputProps={{
                    inputProps: {
                      style: {
                        height: '0.6rem',
                        // textTransform: 'uppercase',
                        fontSize: 'x-small'
                      },
                    },
                    startAdornment: (
                      <InputAdornment position="start">
                        <IconButton>
                          <Search sx={{fontSize:'x-small'}}/>
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Box>
            <DataGrid
                rows={gstList}
                columns={columns.map((col) => ({
                  ...col,
                  // flex: col.flex || 1, // Ensure columns resize dynamically
                  minWidth: isSm && (col.minWidth || 150), // Set a minimum width to avoid overlap
                }))}
                // getRowId={(row) => row.id}
                //checkboxSelection={true}
                rowCount={totalRowCount}  // Use the length of the filtered list
                pageSizeOptions={[5, 10, 20, 50, 100]}
                paginationModel={paginationModel}
                paginationMode="server"
                onPaginationModelChange={handlePaginationChange}

                filterModel={filterModel}

                // sortingMode="server"
                // sortModel={sortModel}                  
                // onSortModelChange={handleSortingChange}
                // disableMultiSort={true}

                loading={loadingList}

                disableColumnMenu
                disableRowSelectionOnClick
                slots={{
                    // toolbar: GridToolbar,                        
                    loadingOverlay: Loading,
                    noRowsOverlay: NoRowsLayout,
                }}
                autoHeight
                getRowHeight={() => 'auto'}
                sx={{
                    borderRadius:'0',
                    '& .MuiDataGrid-cell': {
                    border: 1,
                    borderRight: 0,
                    borderTop: 0,
                    borderColor: 'lightgrey',
                    display: 'flex',
                    alignItems: 'center',
                    // justifyContent: 'center',
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        borderBottom: '2px solid rgba(224, 224, 224, 1)',
                    //   borderTop: '2px solid rgba(224, 224, 224, 1)',
                        fontWeight: 600,
                        fontSize: '0.75rem',
                        p:0,
                        height: 'fit-content',
                        minHeight:'0 !important',
                        height:'2rem'
                    },
                    '& .MuiDataGrid-columnHeader': {
                    borderLeft: '1px solid rgba(224, 224, 224, 1)',
                    borderBottom: 'none',
                    '&:first-child': {
                        borderLeft: 'none',
                    },
                    '&:last-child': {
                        borderRight: 'none',
                    },
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                    fontWeight: 600,
                    color: '#3e3e3e'
                    },
                    '& .MuiDataGrid-row': {
                        '& .MuiDataGrid-cell:first-child': {
                        borderLeft: 'none',
                    },
                    '&:last-child .MuiDataGrid-cell': {
                        borderBottom: '1px solid rgba(224, 224, 224, 1)',
                    },
                    '& .MuiDataGrid-cell:last-child': {
                        borderRight: 'none',
                    },
                    },
                    '& .MuiDataGrid-columnSeparator': {
                    display: 'none',
                    },
                }}
            />
        </Box>
    </Card>
  );
}

export default GstTable;
